/** Abstract player intents – input sources (keyboard, touch, gamepad later) map onto these. */
export const InputAction = {
  MoveLeft: 'MOVE_LEFT',
  MoveRight: 'MOVE_RIGHT',
  Jump: 'JUMP',
  Slide: 'SLIDE',
  /** Slide key / finger released – sliding continues while the slide input is held. */
  SlideRelease: 'SLIDE_RELEASE',
  Pause: 'PAUSE',
  Confirm: 'CONFIRM',
  Restart: 'RESTART',
  ToggleDebug: 'TOGGLE_DEBUG',
} as const;

export type InputAction = (typeof InputAction)[keyof typeof InputAction];

/** Actions that affect the simulation and therefore go through the input buffer. */
export type GameplayAction =
  | typeof InputAction.MoveLeft
  | typeof InputAction.MoveRight
  | typeof InputAction.Jump
  | typeof InputAction.Slide
  | typeof InputAction.SlideRelease;

export function isGameplayAction(action: InputAction): action is GameplayAction {
  return (
    action === InputAction.MoveLeft ||
    action === InputAction.MoveRight ||
    action === InputAction.Jump ||
    action === InputAction.Slide ||
    action === InputAction.SlideRelease
  );
}

/** Hold actions and the action their release produces (keyboard key up, finger lifted). */
export const HOLD_RELEASE: Readonly<Partial<Record<InputAction, InputAction>>> = {
  [InputAction.Slide]: InputAction.SlideRelease,
};
